import { useMemo } from 'react';

import { getLineCategory } from '@utils/helper-utils';

import {
  useGetPolicyMedicalCovers,
  useGetPolicyTravelCovers
} from '../amendment.slice';

import { LineCategory } from 'src/enums';

export function usePolicyCoversLovs(
  planId: string,
  selectedCoverIds: string[],
  lineCode: string
) {
  const lineCategory = getLineCategory(lineCode);
  const isTravel = lineCategory === LineCategory.Travel;
  const isMedical = lineCategory === LineCategory.Medical;

  const { data: medicalData } = useGetPolicyMedicalCovers(
    planId && isMedical
      ? {
          variables: { planID: planId },
          skip: !planId || !isMedical
        }
      : { skip: true }
  );

  const { data: travelData } = useGetPolicyTravelCovers(
    planId && isTravel
      ? {
          variables: { planID: planId },
          skip: !planId || !isTravel
        }
      : { skip: true }
  );

  const rawItems = useMemo(() => {
    if (isMedical) {
      return medicalData?.planConfig?.getPolicyMedicalCovers?.items ?? [];
    }
    if (isTravel) {
      return travelData?.planConfig?.getPolicyTravelCovers?.items ?? [];
    }

    return [];
  }, [isMedical, isTravel, medicalData, travelData]);

  const availableCovers = useMemo(() => {
    return rawItems.filter(
      (cover) => !selectedCoverIds.includes(String(cover?.id ?? ''))
    );
  }, [rawItems, selectedCoverIds]);

  const coverOptions = useMemo<Record<string, string>>(() => {
    return availableCovers.reduce(
      (acc, cover) => {
        if (!cover?.id) return acc;
        const label = `${cover.code ?? ''} - ${cover.name ?? ''}`.trim();
        acc[cover.id] = label;

        return acc;
      },
      {} as Record<string, string>
    );
  }, [availableCovers]);

  return {
    rawItems,
    availableCovers,
    coverOptions
  };
}
